<template>
  <v-app>
    <the-parsina-header
      v-if="
        $route.matched[1].name == 'ParsinaSupport' &&
        $route.name != 'parsinaSupportLogin'
      "
    />
    <the-header v-if="$route.matched[1].name != 'ParsinaSupport'" />

    <the-alerts />

    <v-main
      :class="{
        'dashboard-page':
          ($route.name === 'PACNTDashboard' && hasDashboardData) ||
          $route.name === 'PBANKDashboard' ||
          $route.name === 'PHAMYARDashboard',
      }"
    >
      <transition name="fade" mode="out-in">
        <router-view :key="$route.path"></router-view>
      </transition>

      <the-loading />
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import TheHeader from "@/containers/TheHeader";
import TheParsinaHeader from "@/containers/TheParsinaHeader";
import TheAlerts from "@/components/TheAlerts";
import TheLoading from "@/components/TheLoading";

export default {
  name: "TheContainer",
  components: {
    TheHeader,
    TheParsinaHeader,
    TheAlerts,
    TheLoading,
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      items: "pacntX/dashboardAccountOffice",
    }),
    hasDashboardData() {
      return this.items;
    },
  },
  mounted() {
    this.$store.dispatch("phamyarX/restoreTaskTimers");
    this.unregisterRouterHook = this.$router.beforeEach((to, from, next) => {
      this.closeVuetifyTooltips();
      next();
    });
  },

  beforeDestroy() {
    this.unregisterRouterHook?.();
  },

  methods: {    
    closeVuetifyTooltips(vm = this.$root) {
      if (vm === this.$root) document.activeElement?.blur();

      vm.$children.forEach((child) => {
        const name = child.$options.name;
        if ((name === "v-menu" || name === "v-tooltip") && child.isActive) {
          child.isActive = false;
        }
        this.closeVuetifyTooltips(child);
      });
    },
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
